import { useMemo } from 'react';
import { Tooltip } from 'antd';
import PropTypes from 'prop-types';
import './AudioElement.css';

const formatTime = (time) => {
  const min = Math.floor(time / 60);
  const sec = Math.floor(time % 60);
  return `${min}:${sec < 10 ? '0' : ''}${sec}`;
};

function AudioProgressTrack(props) {
  const { currentTime, duration, appearance, markers = [], onSeek } = props;

  const progressPercent = duration ? (currentTime / duration) * 100 : 0;

  const trackStyle = useMemo(
    () => ({
      background: `linear-gradient(to right, #2463eb ${progressPercent}%, ${
        appearance === 'dark' ? '#404040' : '#f0f0f0'
      } ${progressPercent}%)`,
    }),
    [progressPercent, appearance],
  );

  return (
    <>
      <span className="time-display">{formatTime(currentTime)}</span>
      <div className="progress-container">
        <input
          type="range"
          className="seek-bar"
          min="0"
          max={duration || 0}
          value={currentTime}
          onChange={(e) => onSeek(Number(e.target.value))}
          style={trackStyle}
        />
        <div className="markers-overlay">
          {markers.map((m, i) => {
            const dot = (
              <div
                key={`marker-${i}`}
                className="marker-dot"
                style={{ left: `${duration > 0 ? (m.time / duration) * 100 : 0}%` }}
                onClick={(e) => {
                  e.stopPropagation();
                  onSeek(m.time);
                }}
              />
            );
            return m.label ? (
              <Tooltip key={i} title={m.label}>
                {dot}
              </Tooltip>
            ) : (
              dot
            );
          })}
        </div>
      </div>
      <span className="time-display">{formatTime(duration)}</span>
    </>
  );
}

AudioProgressTrack.propTypes = {
  currentTime: PropTypes.number,
  duration: PropTypes.number,
  appearance: PropTypes.string,
  markers: PropTypes.arrayOf(
    PropTypes.shape({
      time: PropTypes.number,
      label: PropTypes.string,
    }),
  ),
  onSeek: PropTypes.func,
};

export default AudioProgressTrack;
